import { useQuery } from '@tanstack/react-query';
import { getNodeTranscript, type TranscriptEntryDto } from '@api/processRuns';
import type { TranscriptEntry } from '../runSession/types';

function mapEntry(e: TranscriptEntryDto): TranscriptEntry {
  if (e.type === 'text') {
    return { type: 'text', text: e.text ?? '', timestamp: e.timestamp };
  }
  return {
    type: 'tool',
    tool: e.tool ?? '',
    toolUseId: e.toolUseId ?? null,
    status: e.status === 'completed' ? 'completed' : 'requested',
    success: e.success,
    summary: e.summary,
    args: e.args,
    timestamp: e.timestamp,
  };
}

export function useNodeTranscript(
  processId: string | undefined,
  runId: string | undefined,
  nodeId: string | undefined,
  iteration: number,
  enabled: boolean,
): readonly TranscriptEntry[] | undefined {
  const { data } = useQuery({
    queryKey: ['node-transcript', processId, runId, nodeId, iteration],
    queryFn: () => getNodeTranscript(processId!, runId!, nodeId!, iteration),
    enabled: enabled && !!processId && !!runId && !!nodeId,
    staleTime: Infinity,
    // A miss is deterministic (node has no state on that run) — retrying
    // just repeats the 404.
    retry: false,
  });
  if (!data) return undefined;
  return data.map(mapEntry);
}
